/**
 * Devlopment
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:14:51
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:14:51
 */

'use client'

import PropTypes from 'prop-types'
import { useCallback, useRef, useState } from 'react'
import { isAU, isNZ } from '@lib/utils'
import { useTranslations } from 'next-intl'
import PropertyItemScoff from '../PropertyItemScoff'
import LocationMapDialog from '../location/LocationMapDialog'
import NzContent from './NzContent'
import AuContent from './AuContent'

export default function Devlopment({
  house = {}
}) {
  const tm = useTranslations('menu')
  const mapDialogRef = useRef() 
  const [locationBarOptionValue, setLocationBarOptionValue] = useState('urbanPlanning')

  const handleIconClick = useCallback((tabName) => {
    setLocationBarOptionValue(tabName)
    mapDialogRef.current.openDialog()
  }, [])
  
  return (
    <PropertyItemScoff 
      title={tm('development')}
      moduleName={tm('development')}
      id="module-development"
    >
      {isNZ && (<NzContent house={house} handleIconClick={handleIconClick} />)}
      {isAU && (<AuContent house={house} handleIconClick={handleIconClick} />)}
      <div className="mt-6 text-center">
        <LocationMapDialog
          ref={mapDialogRef} 
          house={house} 
          tabName="development"
          locationBarOptionValue={locationBarOptionValue}
        />
      </div>
    </PropertyItemScoff>
  )
}

Devlopment.propTypes = {
  house: PropTypes.object,
}
